import { Article } from '@lib/queries';

import { image } from './index.css';

import { Box } from '~/components/box';
import { Image } from '~/components/image';
import { StructuredText } from '~/components/structured-text';
import { Text } from '~/components/text';
import { formatDate } from '~/utils';

const Article = ({ title, datePublished, author, featuredImage, body }: Article) => {
  return (
    <>
      <Box marginTop={{ sm: '-2', lg: '5' }} display="flex" flexDirection="column" gap="1">
        <Text variant="h1">{title}</Text>
        <Box display="flex" flexDirection="column" gap="1">
          <Text variant="body" color="grey">
            Written by
          </Text>
          {author && (
            <Box display="flex" alignItems="center" gap="0.5">
              <Box
                display="flex"
                height="5"
                width="5"
                overflow="hidden"
                borderRadius="radius-round"
                background="ultramarine900"
                alignItems={'center'}
                position="relative"
              >
                <Image {...author?.avatar} fill />
              </Box>
              <Box display="flex" flexDirection="column">
                <Text variant="body" fontWeight="medium">
                  {author?.name}
                </Text>
                <Text variant="body" color="grey">
                  {author?.title}
                </Text>
              </Box>
            </Box>
          )}
          <Text color="grey" variant="body">
            Published {datePublished && formatDate(datePublished, 'd MMMM yyyy')}
          </Text>
        </Box>
        <Box position="relative" className={image} marginTop="1">
          <Image {...featuredImage} fill />
        </Box>
        <StructuredText value={body} />
      </Box>
    </>
  );
};

export { Article };
